<template>
    <div class="page">
        <v-container :class="{'px-0': phoneOnly}">
            <v-card :flat="phoneOnly" class="px-lg-3 px-1" :class="{'transparent': phoneOnly, 'soft-shadow': pcOnly}" style="min-height: 50vh">

                <div class="d-flex flex-column flex-lg-row justify-space-between px-4">
                    <div>
                        <v-btn v-for="category in categoriesItems" :key="category.value" depressed :color="selectedCategory === category.value ? 'primary' : 'grey lighten-3'" class="me-2 mb-1" @click="selectedCategory = category.value">{{ category.text }}</v-btn>
                    </div>
                    <div class="d-flex flex-column flex-lg-row mt-2 mt-lg-0">
                        <v-text-field :disabled="loading || !programs || !programs.length" max-width="300" type="search" :append-icon="searchQuery ? 'mdi-close' : 'mdi-magnify'" @click:append="searchQuery = ''" hide-details label="Search" placeholder="Search in Programs" filled dense v-model="searchQuery" :style="pcOnly ? 'width: 280px;' : ''"/>
                    </div>
                </div>
                <v-card-text>
                    <v-row v-if="programs && programs.length" :key="0">
                        <v-col v-for="program in visiblePrograms" :key="program.id" :cols="12" :md="6" :lg="4" :xl="3">
                            <program-card :program="program" style="height: 100%"/>
                        </v-col>
                    </v-row>
                    <v-row class="programs-loading" v-else-if="loading" :key="1">
                        
                    </v-row>
                    <div v-else-if="programs && programs.length === 0" :key="2" class="my-2">
                        <v-alert type="info" color="muted" text>
                            <strong>No Results</strong>
                            <div>We didn't get any programs to view, try reloading page...</div>
                        </v-alert>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import ProgramCard from '@/components/custom/program-card'

export default {
    name: "Programs",
    components: {
        ProgramCard
    },
    data(){
        return {
            searchQuery: '',
            loading: false,
            selectedCategory: 'all',
        }
    },
    computed: {
        programs(){
            return this.$store.state.programsModule.programs;
        },
        visiblePrograms(){
            const query = this.searchQuery.toLowerCase();
            let programs = this.programs;
            if (this.selectedCategory && this.selectedCategory !== 'all'){
                programs = programs.filter(program=>program.category_id === this.selectedCategory);
            }

            if (query){
                return programs.filter(program=>program.name.toLowerCase().search(query) !== -1 || (program.category_name && program.category_name.toLowerCase().search(query) !== -1))
            }

            return programs;
        },
        categories(){
            let categories = [];
            if (this.programs){
                this.programs.forEach(program=>{
                    // if not exists in categories
                    if (program.category_id && !categories.some(c=>c.id === program.category_id)){
                        categories.push({id: program.category_id, name: program.category_name});
                    }
                });
            }
            return categories;
        },
        categoriesItems(){
            const categoriesItems = this.categories.map(category=>{
                return {text: category.name, value: category.id};
            });
            return [
                {text: 'All', value: 'all'},
                ...categoriesItems
            ]
        },
        ...GlobalComputed
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
    },
    methods: {
        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('loadPrograms').then(()=>{
                    this.loading = false;
                }).catch(()=>{
                    this.loading = false;
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
        ...GlobalMethods
    },
    mounted(){
        this.scrollToTop();
        if (!this.programs || this.programs.length === 0){
            this.loadData();
        }
    }
};
</script>

<style lang="scss">
.programs-loading{
    .v-skeleton-loader__image{
        height: 160px;
    }
}
</style>
